import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  type CheckboxProps,
} from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

interface SingleCheckboxProps {
  label: string;
  props?: CheckboxProps;
}

const SingleCheckbox = ({ label, ...props }: SingleCheckboxProps) => {
  const field = useFieldContext<boolean>();

  const isValid = field.state.meta.errors.length === 0;

  return (
    <FormControl error={!isValid}>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={field.state.value}
              onChange={(e) => field.handleChange(e.target.checked)}
              {...props}
            />
          }
          label={label}
        />
      </FormGroup>
      <ErrorMessage />
    </FormControl>
  );
};
export default SingleCheckbox;
